<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row class="child-flex" >
        <v-card>
          <v-card-text>
            <v-card-title>
              <v-col class="text-h4">Change Password</v-col>
            </v-card-title>
            <v-form>
              <v-text-field
                v-validate="'required'"
                v-model="current_password"
                :error-messages="errors.collect('current_password')"
                type="password"
                label="Previous Password"
                data-vv-name="current_password"
                required />
              <v-text-field
                v-validate="'required'"
                v-model="password"
                :error-messages="errors.collect('password')"
                name="password"
                type="password"
                label="Proposed Password"
                data-vv-name="password"
                required />
              <v-text-field
                v-validate="'required'"
                v-model="password_confirmation"
                :error-messages="errors.collect('password_confirmation')"
                name="password_confirmation"
                type="password"
                label="Proposed Password Confirmation"
                data-vv-name="password_confirmation"
                required />
              <v-btn
                color="primary"
                type="submit"
                class="mr-2"
                @click.prevent="validateAndSubmit"
               >
               Save
               </v-btn>
              <v-btn :to="{ name: 'root_path' }">Cancel</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  name: 'profile',
  data: function () {
    return {
      current_password: '',
      password: '',
      password_confirmation: ''
    }
  },
  methods: {
    validateAndSubmit () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (this.password !== this.password_confirmation) {
            this.$flash({
              showClose: true,
              message: 'Password confirmation does not match',
              type: 'error'
            })
          } else {
            this.changePassword()
          }
        }
      })
    },
    changePassword () {
      this.$store
        .dispatch('changePassword', { oldPassword: this.current_password, newPassword: this.password })
        .then(response => {
          this.$router.push({ name: 'root_path' })
          this.$flash({
            showClose: true,
            message: 'Updated Password',
            type: 'success',
            duration: 1500
          })
        })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: 'Error updating Profile. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    }
  }
}
</script>
